import React, { Component } from 'react'
import rawQuotes from '../../static/quotes/quotes'
import * as quoteStyle from '../components/componentStyles/quote.module.scss'

export class RandomQuote extends Component {
    intervalID = 0;
    state={
        quoteObj:[]
    }
    componentDidMount(){
        var quotesArrSize = rawQuotes.quotes.length;
        let initRandNum = this.getRandomArbitrary(0, quotesArrSize);

        this.setState({
            quoteObj: rawQuotes.quotes[initRandNum]
        },()=>{
            this.intervalID = setInterval(() => {
                let randNum = this.getRandomArbitrary(0, quotesArrSize);
                //console.log(rawQuotes.quotes[randNum].author)
                this.setState({
                    quoteObj: rawQuotes.quotes[randNum]
                })
              }, 15000);
        })
        //console.log(quotesArrSize)
        //console.log(this.getRandomArbitrary(0,quotesArrSize))
    }

    componentWillUnmount(){
        clearInterval(this.intervalID)
        //console.log("quote unmounted...")
    }

    getRandomArbitrary(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }

    render() {
        return (
            <div className={quoteStyle.quoteDiv}>
                <h4><u>Random Favourite Quotes</u></h4>
                <p><i>{"\""+this.state.quoteObj.quote+"\""}</i></p>
                <h6><i>{" # "+this.state.quoteObj.author}</i></h6>
            </div>
        )
    }
}

export default RandomQuote
